// generic module to handle basic user stuff
GP.GPMod('User',function(self) {
    var _vent = function() {},
        _util = null;

    var _data = {
        vc_private_btn: null,
        blocked_users: [],
        tooltip_shown: false,
        tooltip_timer_name: 'verified_tooltip_timer',
        tooltip_verified_link: "<a href='/members/user/verify' data-event='Modal:open'>This user is verified<br/><u>Get verified in seconds</u></a>",
        tooltip_verified_text: "This user is verified",

        // object for storing data associated with user lists (likers, premium purchasers etc...)
        user_list: {
            id: null,
            url: null,
            page: null,
            collection: new self.app.collections.UserList()
        },

        init: function() {
            _vent = self.vent;
            _util = self.app.Util;

            // grab blocked users on init and store locally in our _data.blocked_users array
            apis.update_blocked_users(true);
        }
    };


    var gui = {
        button_loading: function($btn) {
            var $ico,
                loading_text = $btn.data('loading-text');

            if (loading_text) {
                $btn.children('span').text(loading_text);
            }

            $btn.attr('disabled', 'disabled').children('i').each(function(i) {
                $ico = $(this);

                if ($ico.hasClass('normal')) {
                    $ico.addClass('hide');
                } else if ($ico.hasClass('loading')) {
                    $ico.removeClass('hide');
                }
            });
        },
        button_reset: function($btn, remove_disabled) {
            var $ico,
                default_text = $btn.data('default-text');

            if (default_text) {
                $btn.children('span').text(default_text);
            }

            if (remove_disabled === true) {
                $btn.removeAttr('disabled');
            }

            $btn.children('i').each(function(i) {
                $ico = $(this);

                if ($ico.hasClass('normal')) {
                    $ico.removeClass('hide');
                } else if ($ico.hasClass('loading')) {
                    $ico.addClass('hide');
                }
            });
        }
    };

    var apis = {
        update_blocked_users: function(update_other_modules) {
            var api_data = {
                action:     "get_friends",
                filter:     "blocked",
                return_all: true
            };
            return self.api.json('network.blackbook_json', {
                data:    api_data,
                success: function(json) {
                    if (typeof json != 'undefined' && json && json.friends) {
                        _data.blocked_users = json.friends;

                        // update other modules local copy of blocked users if param passed in
                        if (update_other_modules) {
                            _vent.trigger('Cometd:update_blocked_users', _data.blocked_users);
                        }
                    }
                }
            });
        },
        safemode: function(status, url) {
            var post_data = {
                process: 'Submit',
            };

            post_data.safe_mode = (status == 'on') ? 'on' : 'off';

            self.api.json('user.mod_safemode', {
                data: post_data,
                success: function(json) {
                    if (json.status) {
                        if (typeof url !== 'undefined') {
                            window.location.href = url;
                        } else {
                            window.location.reload(true);
                        }
                    }
                }
            });
        },
        content_rating: function(rating) {
            self.api.json('user.mod_content_rating', {
                data: {
                    content_rating: rating
                },
                success: function(json) {
                    if (json.status) {
                        if (json.url) {
                            window.location.href = json.url;
                        } else {
                            window.location.reload(true);
                        }
                    }
                }
            });
        },
        refresh_auth: function(keys) {
            self.api.json('auth.refresh_auth', {
                data: {
                    auth_keys: keys
                },
                success: function(json) {
                    if (typeof json != 'undefined' && json && json.success ) {
                        // do someting based off return value?
                        window.location.reload(true);
                    }
                }
            });
        },
        set_lang: function(lang) {
            $.post('/members/user/set_lang', {
                lang: lang,
            }).done(function(json) {
                if (json.status) {
                    if (json.hasOwnProperty('return_url')) {
                        window.location.href = handlers.get_lang_url(json.return_url, 'set_lang', lang);
                    } else {
                        window.location.reload(true);
                    }
                }
            });
        },
        update_user_status: function(id) {
            self.api.json('user.update_user_status', {
                data: {
                    status_id: id
                },
                success: function(json) {
                    if (typeof json != 'undefined' && json && json.success ) {
                        handlers.user_status_updated();
                    }
                }
            });
        },
        reset_user_status: function() {
            self.api.json('user.update_user_status', {
                data: {
                    reset: true
                },
                success: function(json) {
                    if (typeof json != 'undefined' && json && json.success ) {
                        handlers.user_status_reset();
                    }
                }
            });
        },
        fetch_my_user_obj: function(ctx, cb) {
            // use the callback provided (if applicable)
            var done_cb = function(json) {
                if (typeof json != 'undefined' && json && json.my_user) {
                    GP.sdata.my_user = $.extend(true, {}, json.my_user);

                    if (cb && _util.check_callable(cb)) {
                        cb.call(ctx, json.my_user);
                    }
                }
            };

            self.api.json('auth.get_user_js_obj', {
                data: {
                    log_request: true
                }
            }).done(done_cb);
        },
        gdpr_mark_done: function(post_data) {
            self.api.json('gdpr.download', {
                type: 'POST',
                data: post_data
            });
        },
    };

    var handlers = {
        get_lang_url: function(source_url, key, lang) {
            var rtn = source_url.split("?")[0],
                lang_qs = 'set_lang=' + lang,
                param,
                params_arr = [],
                qs = (source_url.indexOf("?") !== -1) ? source_url.split("?")[1] : "";
            if (qs !== "") {
                params_arr = qs.split("&");

                // remove duplicate set_lang params if any
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                // add set_lang param
                params_arr.push(lang_qs);
                rtn = rtn + "?" + params_arr.join("&");
            } else {
                rtn = rtn + "?" + lang_qs;
            }
            return rtn;
        },
        // callback for successful status update, so let's update any areas that are needed
        user_status_updated: function() {
            $('.user-status-wrap .search-link-wrap').addClass("show");

            // Special case for safari mobile to fix display issue.
            if (_util.check_ios() && _util.check_safari()) {
                $('.user-status-wrap .alert.alert-success').addClass('alert-safari-mobile');
            }

            $('.user-status-wrap .alert.alert-success').show().delay(1500).fadeOut("fast");

        },
        // callback for successful status reset/delete
        user_status_reset: function() {
            $('.user-status-wrap .search-link-wrap').removeClass("show");

            // Special case for safari mobile to fix display issue.
            if (_util.check_ios() && _util.check_safari()) {
                $('.user-status-wrap .alert.alert-success').addClass('alert-safari-mobile');
            }

            $('.user-status-wrap .alert.alert-success').show().delay(1500).fadeOut("fast");
        }
    };

    var events = {
        init: function() {
            // listen for mod_user_credits events and update user's sdata and header elements
            _vent.on(self.moduleName+":mod_user_credits", this.mod_user_credits);

            // listen for check_credits events and check if the user has credits in the db and fire a callback function
            _vent.on(self.moduleName+":check_credits", this.check_credits);

            // trigger an ajax call to update the _data.blocked_users array
            _vent.on(self.moduleName+':update_blocked_users', apis.update_blocked_users);
            _vent.on(self.moduleName+':add_blocked_user', events.add_blocked_user);

            // request handler to request the _data.blocked_users list from this module
            // if callback is supplied, it will fetch and return the updated array
            GP.reqres.setHandler(self.moduleName+':get_blocked_users', events.get_blocked_users);

            // trigger safemode on/off
            _vent.on(self.moduleName+':safemode', apis.safemode);

            // reset auth cookie key(s) from server
            _vent.on(self.moduleName+':refresh_auth', apis.refresh_auth);

            _vent.on(self.moduleName+':setup_ice_breaker', events.setup_ice_breaker);

            _vent.on(self.moduleName + ":setup_user_list_modal", events.setup_user_list_modal);
            _vent.on(self.moduleName + ":toggle_more_users_button", events.toggle_more_users_button);

            _vent.on(self.moduleName+':update_user_status', apis.update_user_status);
            _vent.on(self.moduleName+':reset_user_status', apis.reset_user_status);

            // try and fetch/update the GP.sdata.my_user object if we find that
            // it's missing data (like duid, location etc)
            _vent.on('User:fetch_my_user_obj', apis.fetch_my_user_obj);

            // A/B test for showing confirm email modal for early trial upgrade
            _vent.on(self.moduleName+':setup_confirm_email_modal', events.setup_confirm_email_modal);

            // request 1-to-1 videochat
            _vent.on(self.moduleName+':request_private_videochat', this.vc_request_private);
            _vent.on(self.moduleName+':vc_request_private_send', this.vc_request_private_send);
            _vent.on(self.moduleName+':vc_request_cancel', this.vc_request_cancel);

            // trigger confirm modal to turn off safemode
            _vent.on(self.moduleName+':safemode_confirm_modal', this.safemode_confirm_modal);

            // trigger safemode confirm modal for any clicks on class with 'js-safemodel-modal'
            $(document).on('click', '.js-safemode-modal', function(e) {
                e.preventDefault();

                events.safemode_confirm_modal();
            });

            $(document).on('click', '.js-max-content-notice', function(e) {
                e.preventDefault();
                events.max_content_notice_modal();
            });

            _vent.on(self.moduleName+":setup_content_rating_modal", events.setup_content_rating_modal, this);

            //user interest modal
            _vent.on(self.moduleName + ":setup_user_interest", events.setup_user_interest_modal);

            $(document).on('click', '.btn-set-lang', function(e){
                e.stopImmediatePropagation();
                e.preventDefault();

                var lang = $(this).data('lang');
                apis.set_lang(lang);
            });

            $(document).on('click', '.btn-cancel-account-deletion', function() {
                vent.trigger('Modal:open:confirm', { template: 'GDPR_DELETE_CANCEL_BODY' }, function() {
                   $('#form-cancel-deletion').submit();
                });
            });

            $(document).on('click', 'a.btn.swipe-send-msg', function(e) {
                e.preventDefault();

                var other_duid = $(this).data('duid');
                $.get('/members/msg/get_thread_json/', { duid: other_duid })
                    .done(function(cb_data) {
                        vent.trigger('MessagePane.Inbox:load_thread_external', cb_data);
                    });
            });

            $(document).on('click', '.swipe-disable-notification', function(e) {
                e.preventDefault();

                var promise = $.get('/members/user/disable_swipe_modal/', {});
                promise.done(function(cb_data) {
                    _vent.trigger('Modal:close');
                });

            });

            _vent.on('init_js:gdpr:download', function() {
                $('form.js-ajax').on('submit', function(e) {
                    e.preventDefault();
                });
                $('form.js-ajax button[type=submit], form.js-ajax input[type=submit]').on('click', function(e) {
                    e.preventDefault();

                    var $btn    = $(this),
                        $form   = $btn.parents('.js-ajax'),
                        action  = $form.attr('action'),
                        method  = $form.attr('method');
                        timeout = $form.data('timeout');

                    $.ajax({
                        url:  action,
                        type: (method || 'POST'),
                        data: $form.serialize(),
                        dataType: 'json',
                        beforeSend: function() {
                            gui.button_loading($btn);
                        }
                    }).done(function(json) {
                        if (typeof json != 'undefined' && json) {
                            if (json.verified && json.user_data) {

                                // var data_string = JSON.stringify(json.user_data);
                                // download(data_string, "dlText.txt", "text/plain");

                                $('.js-success').removeClass('hide');
                                gui.button_reset($btn, false);

                                // trigger the download/save of the user_data string
                                if (download(json.user_data, "user_data.txt", "text/plain")) {

                                    var mark_done = {},
                                        form_data = $form.serializeArray();

                                    $.each( form_data, function( i, field ) {
                                        mark_done[field.name] = field.value;
                                    });

                                    // change action from 'verify_and_download' to 'mark_done'
                                    mark_done.action = 'mark_done';
                                    apis.gdpr_mark_done(mark_done);

                                } else {
                                    // download function didn't work?
                                    $('.js-error').removeClass('hide');
                                    gui.button_reset($btn, true);
                                }
                            } else {
                                $('.js-error').removeClass('hide');
                                gui.button_reset($btn, true);
                            }
                        } else {
                            $('.js-error').removeClass('hide');
                            gui.button_reset($btn, true);
                        }
                    }).fail(function(json) {
                        $('.js-error').removeClass('hide');
                        gui.button_reset($btn, true);
                    }).always(function() {
                        // gui.button_reset($btn);
                    });

                });
            });
            _vent.on('init_js:billing:subscription_success', function() {
                $(".js-btn-confirm-email").on("click", function(e){
                    if (!$.cookie('fl_cnfrm_em')) {
                        vent.trigger('Modal:open', {url: '/members/util/confirm_email'});
                        GP.Util.set_cookie('fl_cnfrm_em', 1, 3);
                    } else {
                        window.location.href = GP.Util.clean_url('/members/user/home/');
                    }
                });
            });
            _vent.on(self.moduleName+':toggle_verified_tooltip', this.toggle_verified_tooltip);
            _vent.on(self.moduleName+':setup_verified_tooltip', this.setup_verified_tooltip);

            _vent.on('init_js:videochat:group', function() {
                _vent.trigger("RightDrawer:hide");
            });

            if (GP.Util.check_ios() && GP.Util.check_safari() && window.navigator.standalone) {
                $('body').addClass('standalone-mode');
            }

            if (_util.is_mobile()) {
                this.block_app_install_prompt();
            }
        },
        safemode_confirm_modal: function() {
            _vent.trigger('Modal:open:confirm', {
                template: 'SAFE_MODE',
                backdrop: 'static',
                keyboard: false,
            }, function() {
                _vent.trigger('User:safemode', 'off');
            });
        },
        max_content_notice_modal: function() {
            vent.trigger('Modal:open', {url: '/members/user/content_rating_modal/?notice=1'});
        },
        add_blocked_user: function(bl_duid, blocked_by_duid) {
            if (typeof bl_duid != 'undefined' && bl_duid) {
                var found = false;
                bl_duid = parseInt(bl_duid, 10);

                if (_.isFinite(bl_duid)) {
                    $.each(_data.blocked_users, function(i, user) {
                        if (bl_duid == parseInt(user.duid, 10)) {
                            found = true;
                            return false; // this will break out of jQuery's .each() like break would for a regular loop;
                        }
                    });

                    if (!found) {
                        var blocked_user = {duid: bl_duid};
                        _data.blocked_users.push(blocked_user);
                        _vent.trigger('Chat:update_blocked_users', _data.blocked_users, bl_duid, blocked_by_duid);
                        _vent.trigger('Cometd:update_blocked_users', _data.blocked_users);
                    }
                }
            }
        },
        // either returns the blocked user's in _data.blocked_users, or fetches and calls a provided callback
        get_blocked_users: function(callback) {
            if (typeof callback == 'function') {
                var promise = apis.update_blocked_users();
                promise.always(function() {
                    callback.call(this, _data.blocked_users);
                });
            } else {
                return _data.blocked_users;
            }
        },
        mod_user_credits: function(json, callback, context) {
            if (typeof json != 'undefined' && json && json.hasOwnProperty('credits')) {
                var new_credits = parseInt(json.credits, 10);

                // update our global js reference
                GP.sdata.my_user.credits = new_credits;

                // update all ui instances of credits count
                $('#nav-credits-count span').text(new_credits);
                $('#mobile-sidebar .credits-count').text(new_credits);
                $('#mobile-menu-list .credits-count').text(new_credits);
                $('.chat-credits-count').text(new_credits);
                $('.notify_counter .credits-count').text(new_credits);

                // trigger the callback function if we have one
                if (callback) {
                    if (self.app.Util.check_callable(callback)) {
                        callback.call((context || this));
                    }
                }
            }
        },
        check_credits: function(context, success_callback) {
            // lets check the DB if we have credits (maybe cometd message wasn't received)
            GP.api.json('billing.check_credits', {
                data: {},
                success: function(json) {
                    if (json && json.hasOwnProperty('credits')) {
                        if (typeof success_callback == 'function') {
                            success_callback.call((context || this), json);
                        }
                    }
                }
            });
        },
        setup_ice_breaker: function() {
            $("#btn-ice-breaker").on("click", function(e){
                events.send_ice_breaker();
            });
            $("#btn-close-ice-breaker").on("click", function(e){
                e.preventDefault();
                events.send_ice_breaker(true);
                _vent.trigger('Modal:close');
            });
            GP.Util.set_cookie('fl_shownib', 1, 1);
        },
        send_ice_breaker: function(use_default) {
            var msg = $("select[name='ice_breaker_msg'] option").filter(':selected');
            var ib_msg = (use_default) ? 650 : msg.val();

            if (msg) {
                $.post('/members/user/send_ice_breaker_message/', {ice_breaker_msg: ib_msg}, function(data) {
                    _vent.trigger('Modal:close');
                });
            }
        },
        setup_user_list_modal: function(id) {
            if (typeof(_initial_user_list_data) !== 'undefined') {
                _data.user_list.id = id;
                _data.user_list.page = 1;
                _data.user_list.url = _initial_user_list_data.url;
                // _initial_user_list_data is set in the template
                if (!_.isEmpty(_initial_user_list_data)) {
                    _data.user_list.collection.reset();
                    _data.user_list.collection.add(_initial_user_list_data.content);
                    events.show_user_list_modal();
                }
                $('#btn-more-users').on('click', events.load_more_users);
            }
        },
        setup_user_interest_modal: function(input) {
            var _submit = input.find('button#bs-modal-submit');
            if (_submit.length) {
                _submit.on('click',function(){
                    var interests = {};
                    input.find('input.user-interest').each(function(){
                        interests[$(this).attr('name')] = ($(this).is(':checked') == true)? 1: 0;
                    });

                    events.submit_interest(interests);
                });
            }

            $("div.close-mobile").hide();
        },
        submit_interest: function(interests) {
            self.api.json('/members/user/interests', {
                data: {
                    'interests': interests
                },
                type: 'POST'
            });
        },
        show_user_list_modal: function() {
            var user_list_region = new Marionette.RegionManager();
            var user_list = new self.app.views.UserList({
                collection: _data.user_list.collection,
                sort: false
            });

            user_list_region.addRegions({
                mainRegion: '#user-list-region'
            }).mainRegion.show(user_list);
        },
        load_more_users: function(e) {
            e.preventDefault();
            var _self = $(this);
            $(this).addClass('btn-loading');

            if (_data.user_list.id && !_data.fetching_users) {
                _data.fetching_users = true;

                _data.user_list.collection.fetch({
                    remove: false,
                    url: _data.user_list.url,
                    data: $.param({
                        id: _data.user_list.id,
                        get_users: 1,
                        page: (_data.user_list.page + 1)
                    }),
                    success: function(json) {
                        // incremement offset on load more button.
                        _data.user_list.page++;
                        _self.removeClass('btn-loading');

                        setTimeout(function() {
                            _data.fetching_users = false;
                        }, 300);
                    }
                });
            }
        },
        toggle_more_users_button: function() {
            $('.btn-more-users-wrap').toggleClass('shown');
        },
        setup_confirm_email_modal: function() {
        },
        vc_request_private: function(data, $vc_btn) {
            // save reference to btn to manipulate/close popover
            _data.vc_private_btn = $vc_btn;

            var other_username = data.username;

            _data.vc_private_btn.popover({
                html: true,
                // trigger: 'focus',
                // trigger: 'click',
                trigger: 'manual',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    var html = '';
                    var evnt = ' data-event="User:vc_request_private_send" data-duid="'+data.duid+'" ';
                        evnt += ' data-username="' + other_username + '" ';
                    var cancel_evnt = ' data-event="User:vc_request_cancel" ';

                    if (_allow_private_vc) {
                        html = '<div class="vc-request-popover text-gray-900"><p>Submit a request to start a private 1-to-1 video chat with <span class="username">' + other_username + '</span>?</p><div class="text-center mt-[10px]"><a href="#" '+evnt+' class="btn btn-primary text-white">Send Request</a> <a '+cancel_evnt+' class="btn btn-default no-follow" href="#">cancel</a></div></div>';
                    } else {
                        html = '<p class="text-gray-900">Video chat requests can only be sent to users on your friends list or members that replied to your messages</p><button type="button" '+cancel_evnt+' class="mt-[10px] btn btn-primary btn-dismiss text-white">Ok</button>';
                    }

                    return html;
                }
            });
            _data.vc_private_btn.popover('show');

        },
        vc_request_cancel: function() {
            if (_data.vc_private_btn) {
                _data.vc_private_btn.popover('destroy');
                _data.vc_private_btn = null;
            }
        },
        vc_request_private_send: function(input) {

            if (input.duid) {
                var cancel_evnt = ' data-event="User:vc_request_cancel" ';
                var $popover_content = $('.popover .vc-request-popover');
                var popover_html = '<p class="text-gray-900">Requesting private videochat with ' + input.username + '...</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>';


                // update popover content with msg saying the request is being sent
                $popover_content.html(popover_html);


                var post_data = {
                    name: 'private 1 to 1 chat',
                    isPrivate: true,
                    sendRequest: true,
                    duids: [input.duid]
                };
                var req_url = '/app/members/rooms/private/'+input.duid+'/sendRequest';

                self.api.json(req_url, {
                    data: post_data,
                    type: 'POST'
                }).done(function(json) {

                    if (json && json.vc_url && json.online) {
                        // redirect to private videochat app
                        window.location.href = json.vc_url;

                    } else if (json && !json.online) {
                        // not online error msg
                        $popover_content.html('<p>User is not currently online... Please try again later when user is online</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>');

                        setTimeout(events.vc_request_cancel, 2500);
                    } else {
                        // error msg
                        $popover_content.html('<p>Request failed... Please try again later</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>');

                        setTimeout(events.vc_request_cancel, 2500);
                    }
                }).fail(function() {
                    // error msg
                    $popover_content.html('<p>Request failed... Please try again later</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>');

                    setTimeout(events.vc_request_cancel, 2500);

                }).always(function() {
                    // events.vc_request_cancel();
                });

            }
        },
        setup_content_rating_modal: function() {
            var _modal_namespace = 'rating-modal';
            $(document).on('click.' + _modal_namespace, '.btn-select-content-rating', function(e) {
                $('.btn-select-content-rating').removeClass('selected');
                $(this).addClass('selected');
                $('#modal-content-rating').val($(this).data('rating'));
            });

            $(document).on('click', '.btn-save-content-rating', function(e) {
                e.preventDefault();
                apis.content_rating($('#modal-content-rating').val());
            });
        },
        setup_verified_tooltip: function($elem) {
            _data.tooltip_shown = false;

            $elem.tooltip({
                trigger: 'manual',
                placement: 'bottom',
                html: true,
                sanitize: false,
                title: function() {
                    if (GP.sdata.my_user.verified_pic === 'N') {
                        return _data.tooltip_verified_link;
                    } else {
                        return _data.tooltip_verified_text;
                    }
                }
            })
            .on('click', function() {
                if (!_data.tooltip_shown) {
                    $(this).tooltip('show');
                }
            })
            .on('hidden.bs.tooltip', function() {
                _data.tooltip_shown = false;
            })
            .on('shown.bs.tooltip', function() {
                _data.tooltip_shown = true;

                _util.timers.set(function() {
                    events.hide_verified_tooltip($elem);
                }, 3000, _data.tooltip_timer_name);

                $('html').on('click.tooltipOff', function(e) {
                    // close tooltip if clicking anywhere outsite the tooltip
                    if (!$(e.target).parent().hasClass('tooltip')) {
                        events.hide_verified_tooltip($elem);
                    }
                });
            });
        },
        hide_verified_tooltip: function($elem) {
            $elem.tooltip('hide');
            $('html').off('click.tooltipOff');
            _util.timers.clear(_data.tooltip_timer_name);
        },
        // Prevents the default broswer install dialog from appearing on mobile
        block_app_install_prompt: function() {
            window.addEventListener('beforeinstallprompt', (event) => {
                event.preventDefault();
            });
        }
    };

    self.utils = {
        check_my_user_obj: function() {
            var required_fields = ['duid', 'username', 'rt_auth_hash', 'gender', 'age'/*, 'city'*/],
                my_user_chk     = true;

            if (typeof GP.sdata.my_user != 'undefined' && GP.sdata.my_user) {
                var user = GP.sdata.my_user;

                $.each(required_fields, function(i, field) {
                    if (!user[field]) {
                        my_user_chk = false;
                    }
                });
            } else {
                my_user_chk = false;
            }

            return my_user_chk;
        }
    };

    this.addInitializer(function() {
        _data.init();
        events.init();

        // make sure we've got good data for GP.sdata.my_user
        if (self.utils.check_my_user_obj() === false) {
            _vent.trigger('User:fetch_my_user_obj');
        }
    });
});
